import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import { subscribeToChanges } from '../lib/realtimeSubscriptions';

export function useUnreadTickets(userId) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setUnreadCount(0);
      setLoading(false);
      return;
    }

    let active = true;
    // Fetch initial unread count
    const fetchUnreadCount = async () => {
      try {
        const { data, count, error } = await supabase
          .from('support_tickets')
          .select('id, subject, read_by_user, status, updated_at', { count: 'exact', head: false })
          .eq('user_id', userId)
          .eq('read_by_user', false);

        if (error) throw error;
        if (active) setUnreadCount(count || 0);
      } catch (error) {
        if (active) setUnreadCount(0);
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchUnreadCount();

    // Listen for custom event from MyTickets page
    const handleTicketsMarkedRead = () => {
      fetchUnreadCount();
    };
    
    window.addEventListener('tickets-marked-read', handleTicketsMarkedRead);

    // Real-time subscription for updates
    const unsubscribe = subscribeToChanges(supabase, `unread-tickets-${userId}`,
        {
          event: '*',
          schema: 'public',
          table: 'support_tickets',
          filter: `user_id=eq.${userId}`,
        },
        () => {
          // Refetch count when any ticket changes
          fetchUnreadCount();
        }
      );

    return () => {
      active = false;
      unsubscribe();
      window.removeEventListener('tickets-marked-read', handleTicketsMarkedRead);
    };
  }, [userId]);

  return { unreadCount, loading };
}
